export default (bankAccounts = []) => {
    const accountNumber = bankAccounts
        .filter(bankAccount => bankAccount.autoPayout)
        .map(bankAccount => bankAccount.accountNumber)[0];

    if (accountNumber && accountNumber.length === 11) {
        return `${accountNumber.substring(0, 4)}.${accountNumber.substring(
            4,
            6
        )}.${accountNumber.substring(6)}`;
    }

    return '';
};



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/autoPayoutFormatter.js